import { Form } from "antd";
import styled, { css } from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 15px 83px;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 25px 0 15px 16px;
  }
  overflow: auto;

  .ant-input-affix-wrapper-disabled {
    background: ${theme.colors.neutral.black7};
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
`;

const StickyHeaderElem = css`
  height: 70px;
  position: sticky;
  top: 0;
`;

export const LeftSideWrapper = styled.div`
  display: flex;
  ${StickyHeaderElem}
`;

export const RightSideWrapper = styled.div`
  ${StickyHeaderElem}
`;

export const BackIcon = styled.img`
  margin-top: 12px;
  margin-right: 15px;
  cursor: pointer;
  height: 21px;
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin: 0;
`;

export const Body = styled.div`
  height: 324px;
  background: white;
  padding: 32px 39px;
  font-size: 14px;

  input,
  textarea,
  .ant-select-selection-item {
    font-size: 14px;
  }

  .ant-input-suffix {
    display: none;
  }
`;

export const PStyled = styled.p`
  color: #e15126;
  cursor: pointer;
  margin-top: -7px;
`;

export const SwitchWrapper = styled.div`
  margin-top: -12px;
  display: flex;
`;

export const ActiveStyled = styled.p`
  padding: 0 10px;
`;

export const LoggedInStyled = styled.p`
  color: ${theme.colors.dark};
`;

export const FormItem = styled(Form.Item)`
  height: 4rem;
`;

export const ModalButtonsWrapper = styled.div`
  display: flex;
  float: right;
  margin-top: 30px;
  column-gap: 21px;

  & #cancel_btn {
    background: ${theme.colors.neutral.black6};
    border: 1px solid ${theme.colors.neutral.black6};
  }
`;

export const PopconfirmTitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: ${theme.colors.custom.background};
`;
